// Prevents the user from scrolling the body when a dropdown is
export function lockBodyPos() {
  document.body.classList.add('locked');
}
export function unlockBodyPos() {
  document.body.classList.remove('locked');
}
